const monthFormatter = new Intl.DateTimeFormat("en-US", { month: "short", year: "2-digit" });

export const formatMoney = (amountInCents = 0, currency = "usd") =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: String(currency || "usd").toUpperCase(),
    maximumFractionDigits: 0,
  }).format(Number(amountInCents || 0) / 100);

export const formatNumber = (value = 0) =>
  new Intl.NumberFormat("en-US", { maximumFractionDigits: 1 }).format(Number(value || 0));

export const toDate = (value) => {
  if (!value) return null;
  if (value instanceof Date && !Number.isNaN(value.getTime())) return value;
  if (typeof value?.toDate === "function") {
    const dt = value.toDate();
    if (dt instanceof Date && !Number.isNaN(dt.getTime())) return dt;
  }
  const seconds = Number(value?.seconds || value?._seconds || 0);
  if (seconds > 0) return new Date(seconds * 1000);
  const numberValue = Number(value || 0);
  if (numberValue > 0) return new Date(numberValue > 1e12 ? numberValue : numberValue * 1000);
  return null;
};

export const monthKeyFromDate = (date) => {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return "";
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;
};

export const monthLabel = (monthKey) => {
  if (!monthKey || !String(monthKey).includes("-")) return String(monthKey || "");
  const [year, month] = String(monthKey).split("-");
  const dt = new Date(Number(year), Number(month) - 1, 1);
  if (Number.isNaN(dt.getTime())) return String(monthKey);
  return monthFormatter.format(dt);
};

export const lastMonthKeys = (count = 6) => {
  const now = new Date();
  return Array.from({ length: count }).map((_, index) => {
    const dt = new Date(now.getFullYear(), now.getMonth() - (count - 1 - index), 1);
    return monthKeyFromDate(dt);
  });
};

export const buildMonthlySeries = (rows = [], getMonthKey, getValue, monthCount = 6) => {
  const keys = lastMonthKeys(monthCount);
  const totals = keys.reduce((acc, key) => ({ ...acc, [key]: 0 }), {});

  rows.forEach((row) => {
    const key = getMonthKey(row);
    if (!key || !(key in totals)) return;
    totals[key] += Number(getValue(row) || 0);
  });

  return keys.map((key) => ({
    key,
    label: monthLabel(key),
    value: totals[key] || 0,
  }));
};
